import { Pipe, PipeTransform } from "@angular/core";
import { truncateFixed } from "@helpers/utils";

@Pipe({
	name: "truncate_fixed",
	standalone: false
})
export class TruncateFixedPipe implements PipeTransform {
	public transform(value: number, precision: number): string {
		return truncateFixed(value, precision);
	}
}
